import script from "./MResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./MResult.vue?vue&type=script&setup=true&lang=ts"

import "./MResult.vue?vue&type=style&index=0&id=56fabec4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56fabec4"]])

export default __exports__